<template>
  <form @submit.prevent="onContinue">
    <p class="pb-2 text-sm font-bold text-primary md:text-lg font-lufthansa-head">
      {{ tr('pages.sales.buy.selector.title') }}
    </p>
    <div class="flex flex-wrap justify-between mb-4">
      <TextInput
        v-model="desiredAmount"
        :placeholder="tr('pages.sales.buy.desiredAmount.label')"
        :label="tr('pages.sales.buy.desiredAmount.label')"
        :error="desiredAmountError"
        autocomplete="off"
      />
    </div>

    <div v-if="shouldShowMultiCurrency" class="flex flex-wrap justify-between mb-4">
      <Select
        v-model="selectedCurrency"
        :options="currencyOptions"
        :label="tr('pages.sales.buy.currency.label')"
        :placeholder="tr('pages.sales.buy.currency.placeholder')"
        :error="currencyError"
        :reduce="data => data.code"
        class="w-full"
      />
    </div>

    <Alert
      class="my-8"
      variant="warning"
      :title="tr('pages.sales.buy.disclaimer.title')"
      :message="tr('pages.sales.buy.disclaimer.text')"
    />

    <Button
      variant="secondary"
      :loading="isLoading"
      full-width
      type="submit"
    >
      {{ tr('pages.sales.buy.selector.continue') }}
    </Button>
  </form>
</template>

<script>
import VoucherAmountSelector from '~brand-components/base/sale/voucher-amount-selector'

import Button from '~brand-components/lufthansa/button/button.vue'
import Select from '~brand-components/lufthansa/select/select.vue'
import TextInput from '~brand-components/lufthansa/shared/text-input.vue'
import Alert from '../alert/alert'

export default VoucherAmountSelector.extend({
  components: {
    TextInput,
    Alert,
    Button,
    Select,
  },
  computed: {
    currencyOptions() {
      return [
        { code: 'eur', label: 'EUR' },
        { code: 'usd', label: 'USD' },
      ]
    },
    defaultCurrency() {
      return 'eur'
    },
  },
})
</script>

<style lang="scss">
.tooltip {
  @apply
    absolute
    bottom-0
    right-0
    mb-8
    -mr-3.4
    w-64
    bg-white
    shadow-5
    border
    border-gray-300
    text-xs
    font-normal
    px-4
    py-3;

  @screen md {
    @apply -ml-3.4 left-0;
  }

  &::before {
    content: "";
    bottom: -5px;
    width: 10px;
    height: 10px;

    @apply
      absolute
      right-0
      mr-4
      border-b
      border-r
      border-gray-300
      bg-white
      transform
      rotate-45;

    @screen md {
      @apply left-0 ml-4 mr-0 right-auto;
    }
  }
}
</style>
